(function () {
  'use strict';

  var cfg = window.GeoBlockConfig || window.USGeoBlockConfig;
  if (!cfg || !cfg.enabled || !cfg.rulesRaw) return;

  function getCurrentProductId() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return String(window.ShopifyAnalytics.meta.product.id);
    }
    var el = document.querySelector('[data-productid]');
    if (el) return String(el.getAttribute('data-productid'));
    var meta = document.querySelector('meta[property="product:id"]');
    if (meta) return String(meta.getAttribute('content'));
    return null;
  }

  var productId = getCurrentProductId();
  if (!productId) return;

  /* ---- 解析规则：US:1,2,3 ---- */
  function parseRules(raw) {
    var map = {};

    String(raw)
      .split(/\r?\n/)
      .map(function (line) { return line.trim(); })
      .filter(Boolean)
      .forEach(function (line) {
        var idx = line.indexOf(':');
        if (idx === -1) return;

        var country = line.slice(0, idx).trim().toUpperCase();
        var idsRaw = line.slice(idx + 1).trim();
        if (!country || !idsRaw) return;

        var ids = idsRaw
          .split(',')
          .map(function (s) { return String(s).trim(); })
          .filter(Boolean);

        if (!ids.length) return;

        if (!map[country]) map[country] = {};
        ids.forEach(function (id) {
          map[country][id] = true;
        });
      });

    return map;
  }

  var rulesMap = parseRules(cfg.rulesRaw);

  function isProductBlockedInAnyCountry(pid) {
    for (var country in rulesMap) {
      if (rulesMap[country] && rulesMap[country][pid]) return true;
    }
    return false;
  }

  if (!isProductBlockedInAnyCountry(productId)) return;

  function shouldBlock(countryCode, pid) {
    countryCode = String(countryCode || '').toUpperCase();
    return !!(rulesMap[countryCode] && rulesMap[countryCode][pid]);
  }

  /* ---- 缓存 ---- */
  var CACHE_KEY = 'tr_geo_v2';
  var CACHE_TTL = 3600 * 1000;

  function getCached() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.country || !obj.ts) return null;
      if (Date.now() - obj.ts > CACHE_TTL) return null;
      return String(obj.country).toUpperCase();
    } catch (e) {
      return null;
    }
  }

  function setCache(country) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        country: String(country || '').toUpperCase(),
        ts: Date.now()
      }));
    } catch (e) {}
  }

  /* ---- 临时隐藏按钮 ---- */
  var STYLE_ID = 'tr-geo-pending-style';

  function injectHideStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '[name="add"]',
      '.t4s-product-form__submit',
      '[data-shopify="payment-button"]',
      'shopify-accelerated-checkout',
      '.shopify-payment-button',
      '[data-quantity-wrapper]',
      '.t4s-quantity-wrapper'
    ].join(',') + '{ display: none !important; }';
    document.head.appendChild(s);
  }

  function removeHideStyle() {
    var s = document.getElementById(STYLE_ID);
    if (s) s.parentNode.removeChild(s);
  }

  /* ---- 提示 ---- */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function insertNotice() {
    if (document.getElementById('tr-geo-block-notice')) return;

    var color = (cfg.notice && cfg.notice.color) || '#cc0000';
    var title = (cfg.notice && cfg.notice.title) || 'Unavailable in Your Region';
    var body = (cfg.notice && cfg.notice.body) || 'This product is currently unavailable in your region.';

    function run() {
      var anchor =
        document.querySelector('.t4s-product-form__buttons') ||
        document.querySelector('.t4s-product-form__variants') ||
        document.querySelector('[data-pr-price]');

      if (!anchor || !anchor.parentNode) return;

      var notice = document.createElement('div');
      notice.id = 'tr-geo-block-notice';

      Object.assign(notice.style, {
        background: color + '14',
        border: '1px solid ' + color,
        borderRadius: '8px',
        padding: '16px 20px',
        marginBottom: '16px',
        color: color,
        fontSize: '14px',
        lineHeight: '1.6',
        fontFamily: 'inherit'
      });

      notice.innerHTML =
        '<strong style="display:block;margin-bottom:4px;font-size:15px;">⚠️ ' + escHtml(title) + '</strong>' +
        '<span style="color:#555;">' + escHtml(body) + '</span>';

      anchor.parentNode.insertBefore(notice, anchor);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }

  /* ---- 主逻辑 ---- */
  var cached = getCached();

  if (cached) {
    if (shouldBlock(cached, productId)) {
      injectHideStyle();
      insertNotice();
    }
    return;
  }

  injectHideStyle();

  fetch('https://ipapi.co/json/')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var country = String((data && data.country_code) || '').toUpperCase();
      setCache(country);

      if (shouldBlock(country, productId)) {
        insertNotice();
      } else {
        removeHideStyle();
      }
    })
    .catch(function () {
      removeHideStyle();
    });

})();